// Module
var code = "<div multi-bar-chart=multiBarChartInput is-already-converted=true></div> ";
// Exports
module.exports = code;